export class LocalStorage {
	private static data: Record<string, any> = {};

	public static set(name: string, value: string): void {
		LocalStorage.data[name] = value;

		try {
			if (window.localStorage) {
				window.localStorage.setItem(name, value);
			}
		} catch (e) {
			// NOTE: Ha nincs ilyen funkció akkor nem használjuk
		}
	}

	public static get(name: string): string {
		try {
			if (window.localStorage) {
				return window.localStorage.getItem(name);
			}
		} catch (e) {
			// NOTE: Ha nincs ilyen funkció akkor nem használjuk
		}

		return LocalStorage.data[name];
	}

	public static remove(name: string): void {
		LocalStorage.data[name] = undefined;

		try {
			if (window.localStorage) {
				window.localStorage.removeItem(name);
			}
		} catch (e) {
			// NOTE: Ha nincs ilyen funkció akkor nem használjuk
		}
	}
}
